export default __webpack_public_path__ + "static/media/shoperPalLogo.5c36966a.png";